import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCodeInsert: React.FC<CentralIconBaseProps> = (props) => {
  return (
    <CentralIconBase {...props} ariaLabel="code-insert">
      <path
        d="M12 5H6C4.34315 5 3 6.34315 3 8V16C3 17.6569 4.34315 19 6 19H12M16 5H18C19.6569 5 21 6.34315 21 8V16C21 17.6569 19.6569 19 18 19H16M16 5V2.5M16 5V19M16 19V21.5M8 9.5L10.5 12L8 14.5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </CentralIconBase>
  );
};

export default IconCodeInsert;
